import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  estateTaskHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  estateTaskHeaderName: {
    marginLeft: '8px',
  },

  link: {
    cursor: 'pointer',
  },
  addTeamMemberLink: {
    margin: 'auto',
    width: '50%',
    color: '#1C2541',
  },
  pointPersonLink: {
    cursor: 'pointer',
    color: 'inherit !important',
    textDecoration: 'inherit !important',
  },
  estateTaskRowLabelCompleted: {
    lineHeight: '1.43',
    color: '#1C2541',
  },
  estateTaskRowLabelNotCompleted: {
    lineHeight: '1.43',
    color: '#434E59',
  },
  estateTaskRowLabelHint: {
    lineHeight: '1.43',
    fontSize: '.75rem',
    color: '#999',
  },
  estateTaskRowNoLabelHint: {
    height: 0,
    visibility: 'hidden',
  },
  linearProgress: {
    marginTop: '0.5em',
    marginBottom: '1em',
    width: '100%',
  },
  linearProgressHeader: {
    fontWeight: 400,
    lineHeight: '22px',
  },
  libraryAddCheck: {
    width: '16px',
    height: '16px',
    verticalAlign: 'middle',
    marginRight: '0.3em',
  },
  estateTaskInstanceMenuIconButton: {
    textAlign: 'right',
  },
  hideTaskButton: {
    color: '#1C2541',
  },
  quickActionSection: {
    position: 'relative',
    zIndex: 100,
  },
  quickActionButton: {
    margin: 0,
    paddingLeft: 0,
    paddingRight: 0,
    color: '#1C2541',
    minWidth: 'unset',
    width: theme.spacing(6),
    align: 'center',
  },
  accordionDetailsBox: {
    display: 'flex',
    alignItems: 'center',
  },
  accordionDetailsBoxInner: {
    width: '100%',
    mr: 1,
  },
  labelContainer: {
    minHeight: 50,
  },
  deadlineText: {
    fontSize: '12px',
    color: '#9E2B25',
    display: 'flex',
    alignItems: 'center',
  },
  editDeadlineIcon: {
    cursor: 'pointer',
  },
  checkbox: {
    '&.Mui-disabled': {
      '& .MuiSvgIcon-root': {
        color: 'rgba(0, 0, 0, 0.26)',
      },
    },
  },
  taskRowsWrapper: {
    padding: '5px 15px 15px 15px',
  },
  searchBarContainer: {
    display: 'flex',
    width: '100%',
    marginTop: theme.spacing(2),
    justifyContent: 'center',
    justifyItems: 'center',
  },
  searchBar: {
    width: '80%',
  },
  inputAdornmentStyle: {
    color: '#999',
    '&:hover': {
      color: '#5ED1F0',
    },
  },
}));
